/**
 * Internal dependencies
 */
import { createRegistry } from './registry';

const defaultRegistry = createRegistry();

export default defaultRegistry;
